import styles from './RichText.module.scss';
import classNames from 'classnames';
export interface RichText {
	content: string;
	linkColor?: 'light';
	style?: 'large';
	className?: string;
	noBottomMargin?: boolean;
}

export const UI_RichText = ({ content, linkColor, style, noBottomMargin, className }: RichText) => {
	return (
		<div
			className={classNames(
				styles.RichText,
				styles[`RichText___${style}`],
				{
					[styles.RichText___lightLink]: linkColor == 'light',
					[styles.RichText___noBottomMargin]: noBottomMargin,
				},
				className,
			)}
			dangerouslySetInnerHTML={{ __html: content }}
		/>
	);
};
